// extracted by mini-css-extract-plugin
export var originalPrice = "_ve-0";